<template>
  <button
    @click.stop="emitInput"
    class="text-md uppercase font-medium border-2"
    :class="css || {'button-white': white, 'button-black': black, 'border-warning text-warning hover:bg-warning': warning, 'border-green-500 text-green-500 hover:bg-green-500': green, 'button-transparent button-no-spacing': transparent, 'px-4': !transparent }"
    :disabled="disabled"
  >
    <span class="mx-2" v-if="sending || icon">
      <icon
        :name="sending ? 'Loading' : icon"
        :size="iconSize"
        offsety="2"
        :settings="{strokeWidth:
      iconStroke}"
      />
    </span>
    <span :class="{'mr-2': sending, 'mx-2': !sending}">
      <slot />
    </span>
  </button>
</template>

<script>
export default {
  name: "WdButton",
  data() {
    return {};
  },
  props: {
    white: {
      default: false,
      type: Boolean
    },
    black: {
      default: false,
      type: Boolean
    },
    green: {
      default: false,
      type: Boolean
    },
    warning: {
      default: false,
      type: Boolean
    },
    disabled: {
      default: false,
      type: Boolean
    },
    transparent: {
      default: false,
      type: Boolean
    },
    css: {
      default: "",
      type: String
    },
    sending: {
      type: Boolean,
      default: false
    },
    icon: {
      default: null,
      type: String
    },
    iconSize: {
      default: "1.5em",
      type: String
    },
    iconStroke: {
      default: "1.5",
      type: String
    }
  },
  components: {},
  methods: {
    emitInput() {
      this.$emit("input");
    }
  },
  computed: {},
  created() {}
};
</script>
